export default "__VITE_ASSET__BlSx8V09__"